import * as api from '../../services/ticket'

export const FETCH_TICKETS= 'FETCH_TICKETS';



export const fetchTickets = (params) => ({
    type: FETCH_TICKETS,
    payload: {
        promise: api.findTickets(params)
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/ticket.js